import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { CoreConstants } from "../../../core/models/constants/core.constants";
import DynamicForm from "../../../core/presentations/DynamicForm";
import { useToasterFacade } from "../../../ui/facades/toaster.facade";
import Validators from "../../../ui/helpers/validators";
import TopLabelFieldTemplate from "../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../ui/templates/objects/VerticalFormTemplate";
import PrwcBasicButton from "../../../ui/widgets/custom/buttons/PrwcBasicButton";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const toasterFacade = useToasterFacade();
  const [formData, setFormData] = useState(null);

  const onChange = (formData: any) => {
    setFormData(formData);
  };

  const validationSchema: any = {
    workEmailId: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "forgotPassword.validation.workEmailRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isRegexPatternValid(
              CoreConstants.REGEX_EMAIL,
              value
            );
          },
          messageKey: "forgotPassword.validation.workEmailInvalid",
        },
        {
          validate: (value: string) => {
            return !Validators.isPersonalEmail(value);
          },
          messageKey: "forgotPassword.validation.workEmailNotWorkEmail",
        },
      ],
    },
  };

  const schema: any = {
    type: "object",
    properties: {
      workEmailId: {
        type: "string",
        title: t("signIn.label.workEmailId"),
        default: "",
      },
    },
    required: ["workEmailId"],
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    workEmailId: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
    },
  };

  const onSubmit = (data: any) => {
    toasterFacade.showSuccess(
      t("forgotPassword.msg.success.emailSentSuccessfully")
    );
    history.replace("set-password");
  };

  const onError = (data: any) => {};

  const handleOtherOptions = () => {};

  const formButtons = () => {
    return (
      <PrwcBasicButton
        type="submit"
        labelKey="forgotPassword.action.sendEmail"
        className="bg-blue-700 p-col-12 p-button-sm"
      ></PrwcBasicButton>
    );
  };

  return (
    <div className="p-6 bg-gray-100 rounded-md">
      <div className="text-2xl font-semibold">
        {t("forgotPassword.label.forgotPassword")}
      </div>
      <div className="text-sm">
        {t("forgotPassword.label.typeInYourRegisteredEmail")}
      </div>
      <div className="mt-4">
        <DynamicForm
          onChange={onChange}
          formData={formData}
          onSubmit={onSubmit}
          onError={onError}
          schema={schema}
          uiSchema={uiSchema}
          validationSchema={validationSchema}
          formButtons={() => formButtons()}
        ></DynamicForm>
      </div>
      <div className="flex items-center justify-between my-2">
        <div>
          <span className="text-sm font-medium">
            {t("forgotPassword.label.cannotAccessYourAccount")}
          </span>
          <span
            onClick={handleOtherOptions}
            className="mx-1 text-sm font-medium text-blue-700 cursor-pointer"
          >
            {t("forgotPassword.label.otherOptions")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
